import React from 'react';
import style from './TeamAction.module.css';

function TeamAction({title, text, icon}) {

    return (
        <div className={style.main}>
            <div className={style.icon}>
                {icon}
            </div>

            <div className={style.title}>
                {title}
            </div>

            <div className={style.text}>
                {text}
            </div>
        </div>
    );
}

export default TeamAction;